/**
 * 文件说明:
 *
 * hz Sentry init
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import * as Sentry from '@sentry/browser'

if (HUZAN_ENV === 'production-master') {
    Sentry.init({
        dsn: 'https://a16be6a0198b4c53ba31646b9cdaeb57@sentry.scrm.miniso.com/11',
        environment: HUZAN_ENV,
    })
}
